import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { excludeFromFilteringColumnProperty } from '@client-shared/ui-agGrid';

import AgGrid from '../shared/agGrid/agGrid.component';
import * as sharedActions from '../shared/store/actions'; // eslint-disable-line import/no-namespace
import SearchBar from '../shared/searchBar/searchBar.component';
import LinkCellRenderer from '../shared/cellRenderers/linkCellRenderer.component';
import StatusCellRenderer from '../shared/cellRenderers/statusCellRenderer.component';
import DateCellRenderer from '../shared/agGrid/cellRenderers/dateCellRenderer.component';
import { alignLeftCellStyle } from '@common/cellStyles';

import { isFetchingCompanyCodesSelector } from '../shared/store/selectors';

const defaultColumnDefs = {
  suppressSizeToFit: true,
};

const columnDefs = [
  {
    cellRenderer: LinkCellRenderer,
    headerName: 'Company Code',
    field: 'cc',
    width: 120,
    ...alignLeftCellStyle,
  },
  {
    ...alignLeftCellStyle,
    headerName: 'Description',
    field: 'desc',
    width: 410,
  },
  {
    headerName: 'Legal Entity',
    field: 'legalEntity',
    width: 80,
    ...alignLeftCellStyle,
  },
  {
    ...alignLeftCellStyle,
    ...excludeFromFilteringColumnProperty,
    headerName: 'Legal Entity Description',
    field: 'legalDesc',
    hide: true,
  },
  {
    ...alignLeftCellStyle,
    headerName: 'Country',
    field: 'country',
    width: 180,
  },
  {
    headerName: 'Country Code',
    field: 'countryCode',
    width: 100,
    hide: true,
  },
  {
    ...excludeFromFilteringColumnProperty,
    cellRenderer: StatusCellRenderer,
    headerName: 'Status',
    field: 'status',
    width: 100,
  },
  {
    ...alignLeftCellStyle,
    ...excludeFromFilteringColumnProperty,
    cellRenderer: DateCellRenderer,
    headerName: 'Last Updated',
    field: 'lastUpdated',
    width: 125,
  },
  {
    ...alignLeftCellStyle,
    ...excludeFromFilteringColumnProperty,
    headerName: 'Connection',
    field: 'connection',
    width: 100,
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'Business Unit',
    field: 'businessUnit',
    width: 100,
  },
  {
    ...alignLeftCellStyle,
    ...excludeFromFilteringColumnProperty,
    headerName: 'Business',
    field: 'businessUnitDesc',
    width: 120,
    hide: true,
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'Business Code',
    field: 'businessCode',
    width: 100,
    hide: true,
  },
  {
    ...alignLeftCellStyle,
    ...excludeFromFilteringColumnProperty,
    headerName: 'Business Description',
    field: 'businessDesc',
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'Functional Currency',
    field: 'functionalCurrency',
    width: 100,
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'STAT Currency',
    field: 'statCurrency',
    width: 100,
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'Tax Currency',
    field: 'taxCurrency',
    width: 100,
    minWidth: 85,
  },
  {
    ...excludeFromFilteringColumnProperty,
    headerName: 'Branch',
    field: 'branch',
    width: 80,
  },
];

class ProvisionsTableWidget extends PureComponent {
  static propTypes = {
    setCompanyCodesFilter: PropTypes.func.isRequired,
    unsetCompanyCodesFilter: PropTypes.func.isRequired,
    companyCodes: PropTypes.arrayOf(PropTypes.shape({
      cc: PropTypes.string.isRequired,
      desc: PropTypes.string,
      country: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      date: PropTypes.string,
    })).isRequired,
    companyCodesFilter: PropTypes.string.isRequired,
    isFetchingCompanyCodes: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isFirstRender: true,
    };
  }

  componentDidMount() {
    if (this.state.isFirstRender) {
      this.props.unsetCompanyCodesFilter();
      this.setState({ isFirstRender: false });
    }
  }

  render() {
    const { companyCodes, isFetchingCompanyCodes } = this.props;

    return (
      <div className="provisions-table-widget a-panel mb-3">
        <div className="card-header">
          <h5>Companies</h5>
          <SearchBar
            onCancel={this.props.unsetCompanyCodesFilter}
            onSearch={this.props.setCompanyCodesFilter}
            placeholder="Search company codes, descriptions, legal entities or countries"
            value={this.state.isFirstRender ? '' : this.props.companyCodesFilter}
          />
        </div>
        <div className="card-body">
          <AgGrid
            columnDefs={columnDefs}
            defaultColDef={defaultColumnDefs}
            rowData={companyCodes}
            quickFilterText={this.props.companyCodesFilter}
            isGridLoading={isFetchingCompanyCodes}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    companyCodes: state.shared.companyCodes,
    companyCodesFilter: state.shared.companyCodesFilter,
    isFetchingCompanyCodes: isFetchingCompanyCodesSelector(state),
  };
}

export default connect(mapStateToProps, sharedActions)(ProvisionsTableWidget);
